import React, { useEffect, useState } from "react";
import { GET } from "../../service/CRUDService";
import FullScreenLoader from "../../common/FullScreenLoader/FullScreenLoader";
import EntityConstants from "../../configs/EntityConstants";
import { useNavigate } from "react-router-dom";
import VpCategoryCard from "../../components/VpCategoryCard/VpCategoryCard";
import { ReactComponent as BreadcrumbArrowBlackIcon } from "../../resources/icons/breadcrumbArrowBlack.svg";
import { ReactComponent as HomeIcon } from "../../resources/icons/home-1-svgrepo-com-gray.svg";
import { useTranslation } from "react-i18next";

const VpVerificationCategory = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const [options, setOptions] = useState([{ name: "All", value: "" }]);
  const [categoriesList, setCategoriesList] = useState([]);
  const [defaultCategoriesList, setDefaultCategoryList] = useState([]);
  const [isLoadingList, setIsLoadingList] = useState(false);

  const getCategoryList = async () => {
    try {
      setIsLoadingList(true);
      const response = await GET(
        `${EntityConstants.GET_VP_CHECKS_CATEGORY_LIST}`
      );
      const data = await response.json();
      setDefaultCategoryList(data?.categories_list);
      setCategoriesList(data?.categories_list);
      setOptions([
        { name: "All", value: "" },
        ...data?.categories_list.map(
          ({ id, name, description, icon, category }) => ({
            name: category,
            value: category.toLowerCase(),
          })
        ),
      ]);
    } catch (error) {
      console.log("error while getting category list: ", error);
    } finally {
      setIsLoadingList(false);
    }
  };

  const handleSearch = (e) => {
    const search = e.target.value;

    if (!search) {
      setCategoriesList(defaultCategoriesList);
    }

    const lowerCaseSearch = search.toLowerCase();
    setCategoriesList(
      defaultCategoriesList.filter((category) =>
        category.name.toLowerCase().includes(lowerCaseSearch)
      )
    );
  };
  useEffect(() => {
    getCategoryList();
  }, []);

  return (
    <div className="flex flex-col items-center w-full pb-3 pt-20 bg-cfSecondary min-h-screen overflow-x-hidden">
      <div
        className="bg-[#F9FAFB] h-16 w-full flex gap-2 items-center px-8"
        id="vp-category"
      >
        <button
          id="vp-category-home-button"
          type="button"
          className="p-0 border-0 bg-transparent cursor-pointer focus:outline-none"
          onClick={() => navigate("/")}
        >
          <HomeIcon className="w-6 h-6 mb-1" />
        </button>
        <BreadcrumbArrowBlackIcon className="w-6 h-6" />
        <p className="font-semibold text-cfTextBreadcrumbActive cursor-pointer">
          {t("request:select_category")}
        </p>
      </div>
      <div className="w-full mt-10 sm:mx-8 sm:mt-8 sm:mb-0 flex flex-col items-center sm:items-start px-8">
        <p className="text-xl font-semibold">
          {t("request:select_category_request")}
        </p>
      </div>
      <div className={`w-full bg-inherit flex justify-center py-[0.8rem] px-8`}>
        <div
          className={`flex flex-col lg-xl:flex-row items-start lg-xl:items-center justify-between w-full`}
        >
          <span className="flex items-center gap-2">
            {/* <Dropdown
              options={options}
              selected={
                options.find((option) => option.value === status) || options[0]
              }
              onSelect={updateStatus}
              buttonClass="border"
              menuClass="z-20"
            /> */}
          </span>
          {/* Search */}
          <form
            onSubmit={(e) => e.preventDefault()}
            className="bg-inherit p-2 rounded-lg w-full lg-xl:w-[25rem] self-center  md:self-end md:m-0 border mt-2"
          >
            <input
              type="text"
              name="search"
              id="vp-category-search-input"
              onChange={(e) => {
                handleSearch(e);
              }}
              placeholder={t("request:search_category")}
              className="outline-none border-none p-0 placeholder:text-sm w-full"
              style={{
                fontSize: "0.875rem",
                lineHeight: "1.25rem",
                background: "transparent",
              }}
            />
          </form>
        </div>
      </div>
      <div className="w-full mx-auto bg-inherit py-8 flex flex-col items-center px-8">
        <div id="category-form" className="w-full">
          {isLoadingList && <FullScreenLoader />}
          {/* <div className='grid grid-cols-auto-fit-minmax gap-2 mt-8'> */}
          <div className="grid gap-6 grid-cols-[repeat(auto-fit,minmax(20rem,1fr))]">
            {categoriesList.map(({ id, name, description, icon }) => (
              <VpCategoryCard
                id={`vp-category-card-${id}`}
                name={name}
                description={description}
                icon={`${icon}`}
                onClick={() => navigate(`/verifier/vp/check/${id}/${name}`)}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default VpVerificationCategory;
